export const PRIORITY_LANGUAGES = [
  {
    key: 'GERMAN',
    value: 'German'
  },
  {
    key: 'ENGLISH',
    value: 'English'
  },
  {
    key: 'FRENCH',
    value: 'French'
  },
  {
    key: 'ITALIAN',
    value: 'Italian'
  },
  {
    key: 'POLISH',
    value: 'Polish'
  },
  {
    key: 'DUTCH',
    value: 'Dutch'
  },
  {
    key: 'SPANISH',
    value: 'Spanish'
  }
];

export const OTHER_LANGUAGES = [
  {
    key: 'MANDARIN',
    value: 'Mandarin'
  },
  {
    key: 'HINDI[A]',
    value: 'Hindi[a]'
  },
  {
    key: 'ARABIC',
    value: 'Arabic'
  },
  {
    key: 'PORTUGUESE',
    value: 'Portuguese'
  },
  {
    key: 'BENGALI',
    value: 'Bengali'
  },
  {
    key: 'RUSSIAN',
    value: 'Russian'
  },
  {
    key: 'JAPANESE',
    value: 'Japanese'
  },
  {
    key: 'PUNJABI',
    value: 'Punjabi'
  },
  {
    key: 'JAVANESE',
    value: 'Javanese'
  },
  {
    key: 'WUSHANGHAINESE',
    value: 'WuShanghainese'
  },
  {
    key: 'MALAYINDONESIANMALAYSIAN',
    value: 'MalayIndonesianMalaysian'
  },
  {
    key: 'TELUGU',
    value: 'Telugu'
  },
  {
    key: 'VIETNAMESE',
    value: 'Vietnamese'
  },
  {
    key: 'KOREAN',
    value: 'Korean'
  },
  {
    key: 'MARATHI',
    value: 'Marathi'
  },
  {
    key: 'TAMIL',
    value: 'Tamil'
  },
  {
    key: 'URDU',
    value: 'Urdu'
  },
  {
    key: 'TURKISH',
    value: 'Turkish'
  },
  {
    key: 'YUECANTONESE',
    value: 'YueCantonese'
  },
  {
    key: 'THAI',
    value: 'Thai'
  },
  {
    key: 'GUJARATI',
    value: 'Gujarati'
  },
  {
    key: 'JIN',
    value: 'Jin'
  },
  {
    key: 'SOUTHERN MINHOKKIENTEOCHEW',
    value: 'Southern MinHokkienTeochew'
  },
  {
    key: 'PERSIAN',
    value: 'Persian'
  },
  {
    key: 'PASHTO',
    value: 'Pashto'
  },
  {
    key: 'KANNADA',
    value: 'Kannada'
  },
  {
    key: 'XIANG',
    value: 'Xiang'
  },
  {
    key: 'MALAYALAM',
    value: 'Malayalam'
  },
  {
    key: 'SUNDANESE',
    value: 'Sundanese'
  },
  {
    key: 'HAUSA',
    value: 'Hausa'
  },
  {
    key: 'ODIA',
    value: 'Odia'
  },
  {
    key: 'BURMESE',
    value: 'Burmese'
  },
  {
    key: 'HAKKA',
    value: 'Hakka'
  },
  {
    key: 'UKRAINIAN',
    value: 'Ukrainian'
  },
  {
    key: 'BHOJPURI',
    value: 'Bhojpuri'
  },
  {
    key: 'TAGALOGFILIPINO',
    value: 'TagalogFilipino'
  },
  {
    key: 'YORUBA',
    value: 'Yoruba'
  },
  {
    key: 'MAITHILI',
    value: 'Maithili'
  },
  {
    key: 'UZBEK',
    value: 'Uzbek'
  },
  {
    key: 'SINDHI',
    value: 'Sindhi'
  },
  {
    key: 'AMHARIC',
    value: 'Amharic'
  },
  {
    key: 'FULA',
    value: 'Fula'
  },
  {
    key: 'ROMANIAN',
    value: 'Romanian'
  },
  {
    key: 'OROMO',
    value: 'Oromo'
  },
  {
    key: 'IGBO',
    value: 'Igbo'
  },
  {
    key: 'AZERBAIJANI',
    value: 'Azerbaijani'
  },
  {
    key: 'AWADHI',
    value: 'Awadhi'
  },
  {
    key: 'GAN',
    value: 'Gan'
  },
  {
    key: 'CEBUANO',
    value: 'Cebuano'
  },
  {
    key: 'KURDISH',
    value: 'Kurdish'
  },
  {
    key: 'SERBO-CROATIAN',
    value: 'Serbo-Croatian'
  },
  {
    key: 'MALAGASY',
    value: 'Malagasy'
  },
  {
    key: 'SARAIKI',
    value: 'Saraiki'
  },
  {
    key: 'NEPALI',
    value: 'Nepali'
  },
  {
    key: 'SINHALA',
    value: 'Sinhala'
  },
  {
    key: 'CHITTAGONIAN',
    value: 'Chittagonian'
  },
  {
    key: 'ZHUANG',
    value: 'Zhuang'
  },
  {
    key: 'KHMER',
    value: 'Khmer'
  },
  {
    key: 'TURKMEN',
    value: 'Turkmen'
  },
  {
    key: 'ASSAMESE',
    value: 'Assamese'
  },
  {
    key: 'MADURESE',
    value: 'Madurese'
  },
  {
    key: 'SOMALI',
    value: 'Somali'
  },
  {
    key: 'MARWARI',
    value: 'Marwari'
  },
  {
    key: 'MAGAHI',
    value: 'Magahi'
  },
  {
    key: 'HARYANVI',
    value: 'Haryanvi'
  },
  {
    key: 'HUNGARIAN',
    value: 'Hungarian'
  },
  {
    key: 'CHHATTISGARHI',
    value: 'Chhattisgarhi'
  },
  {
    key: 'GREEK',
    value: 'Greek'
  },
  {
    key: 'CHEWA',
    value: 'Chewa'
  },
  {
    key: 'DECCAN',
    value: 'Deccan'
  },
  {
    key: 'AKAN',
    value: 'Akan'
  },
  {
    key: 'KAZAKH',
    value: 'Kazakh'
  },
  {
    key: 'NORTHERN MINDISPUTEDDISCUSS',
    value: 'Northern Mindisputeddiscuss'
  },
  {
    key: 'SYLHETI',
    value: 'Sylheti'
  },
  {
    key: 'ZULU',
    value: 'Zulu'
  },
  {
    key: 'CZECH',
    value: 'Czech'
  },
  {
    key: 'KINYARWANDA',
    value: 'Kinyarwanda'
  },
  {
    key: 'DHUNDHARI',
    value: 'Dhundhari'
  },
  {
    key: 'HAITIAN CREOLE',
    value: 'Haitian Creole'
  },
  {
    key: 'EASTERN MINFUZHOU DIALECT',
    value: 'Eastern MinFuzhou dialect'
  },
  {
    key: 'ILOCANO',
    value: 'Ilocano'
  },
  {
    key: 'QUECHUA',
    value: 'Quechua'
  },
  {
    key: 'KIRUNDI',
    value: 'Kirundi'
  },
  {
    key: 'SWEDISH',
    value: 'Swedish'
  },
  {
    key: 'HMONG',
    value: 'Hmong'
  },
  {
    key: 'SHONA',
    value: 'Shona'
  },
  {
    key: 'UYGHUR',
    value: 'Uyghur'
  },
  {
    key: 'HILIGAYNON/ILONGGO',
    value: 'Hiligaynon/Ilonggo'
  },
  {
    key: 'MOSSI',
    value: 'Mossi'
  },
  {
    key: 'XHOSA',
    value: 'Xhosa'
  },
  {
    key: 'BELARUSIAN',
    value: 'Belarusian'
  },
  {
    key: 'BALOCHI',
    value: 'Balochi'
  },
  {
    key: 'KONKANI',
    value: 'Konkani'
  }
];

export const PRIORITY_COUNTRIES = [
  {
    key: 'AUSTRIA',
    value: 'Austria'
  },
  {
    key: 'GERMANY',
    value: 'Germany'
  },
  {
    key: 'SWITZERLAND',
    value: 'Switzerland'
  },
  {
    key: 'FRANCE',
    value: 'France'
  },
  {
    key: 'UNITED KINGDOM',
    value: 'United Kingdom'
  },
  {
    key: 'IRELAND',
    value: 'Ireland'
  },
  {
    key: 'BELGIUM',
    value: 'Belgium'
  },
  {
    key: 'NETHERLANDS',
    value: 'Netherlands'
  },
  {
    key: 'ITALY',
    value: 'Italy'
  },
  {
    key: 'UNITED STATES OF AMERICA',
    value: 'United States of America'
  },
  {
    key: 'CANADA',
    value: 'Canada'
  }
];

export const OTHER_COUNTRIES = [
  {
    key: 'AFGHANISTAN',
    value: 'Afghanistan'
  },
  {
    key: 'ALBANIA',
    value: 'Albania'
  },
  {
    key: 'ALGERIA',
    value: 'Algeria'
  },
  {
    key: 'ANDORRA',
    value: 'Andorra'
  },
  {
    key: 'ANGOLA',
    value: 'Angola'
  },
  {
    key: 'ANTIGUA AND BARBUDA',
    value: 'Antigua and Barbuda'
  },
  {
    key: 'ARGENTINA',
    value: 'Argentina'
  },
  {
    key: 'ARMENIA',
    value: 'Armenia'
  },
  {
    key: 'AZERBAIJAN',
    value: 'Azerbaijan'
  },
  {
    key: 'AUSTRALIA',
    value: 'Australia'
  },
  {
    key: 'BAHAMAS',
    value: 'Bahamas'
  },
  {
    key: 'BAHRAIN',
    value: 'Bahrain'
  },
  {
    key: 'BANGLADESH',
    value: 'Bangladesh'
  },
  {
    key: 'BARBADOS',
    value: 'Barbados'
  },
  {
    key: 'BELARUS',
    value: 'Belarus'
  },
  {
    key: 'BELIZE',
    value: 'Belize'
  },
  {
    key: 'BENIN',
    value: 'Benin'
  },
  {
    key: 'BHUTAN',
    value: 'Bhutan'
  },
  {
    key: 'BOLIVIA',
    value: 'Bolivia'
  },
  {
    key: 'BOSNIA AND HERZEGOVINA',
    value: 'Bosnia and Herzegovina'
  },
  {
    key: 'BOTSWANA',
    value: 'Botswana'
  },
  {
    key: 'BRAZIL',
    value: 'Brazil'
  },
  {
    key: 'BRUNEI',
    value: 'Brunei'
  },
  {
    key: 'BULGARIA',
    value: 'Bulgaria'
  },
  {
    key: 'BURKINA FASO',
    value: 'Burkina Faso'
  },
  {
    key: 'BURUNDI',
    value: 'Burundi'
  },
  {
    key: "CÔTE D'IVOIRE",
    value: "Côte d'Ivoire"
  },
  {
    key: 'CABO VERDE',
    value: 'Cabo Verde'
  },
  {
    key: 'CAMBODIA',
    value: 'Cambodia'
  },
  {
    key: 'CAMEROON',
    value: 'Cameroon'
  },
  {
    key: 'CENTRAL AFRICAN REPUBLIC',
    value: 'Central African Republic'
  },
  {
    key: 'CHAD',
    value: 'Chad'
  },
  {
    key: 'CHILE',
    value: 'Chile'
  },
  {
    key: 'CHINA',
    value: 'China'
  },
  {
    key: 'COLOMBIA',
    value: 'Colombia'
  },
  {
    key: 'COMOROS',
    value: 'Comoros'
  },
  {
    key: 'CONGO (CONGO-BRAZZAVILLE)',
    value: 'Congo (Congo-Brazzaville)'
  },
  {
    key: 'COSTA RICA',
    value: 'Costa Rica'
  },
  {
    key: 'CROATIA',
    value: 'Croatia'
  },
  {
    key: 'CUBA',
    value: 'Cuba'
  },
  {
    key: 'CYPRUS',
    value: 'Cyprus'
  },
  {
    key: 'CZECHIA (CZECH REPUBLIC)',
    value: 'Czechia (Czech Republic)'
  },
  {
    key: 'DEMOCRATIC REPUBLIC OF THE CONGO',
    value: 'Democratic Republic of the Congo'
  },
  {
    key: 'DJIBOUTI',
    value: 'Djibouti'
  },
  {
    key: 'DENMARK',
    value: 'Denmark'
  },
  {
    key: 'DOMINICA',
    value: 'Dominica'
  },
  {
    key: 'DOMINICAN REPUBLIC',
    value: 'Dominican Republic'
  },
  {
    key: 'ECUADOR',
    value: 'Ecuador'
  },
  {
    key: 'EGYPT',
    value: 'Egypt'
  },
  {
    key: 'EL SALVADOR',
    value: 'El Salvador'
  },
  {
    key: 'EQUATORIAL GUINEA',
    value: 'Equatorial Guinea'
  },
  {
    key: 'ERITREA',
    value: 'Eritrea'
  },
  {
    key: 'ESTONIA',
    value: 'Estonia'
  },
  {
    key: 'ESWATINI',
    value: 'Eswatini'
  },
  {
    key: 'ETHIOPIA',
    value: 'Ethiopia'
  },
  {
    key: 'FIJI',
    value: 'Fiji'
  },
  {
    key: 'FINLAND',
    value: 'Finland'
  },
  {
    key: 'GABON',
    value: 'Gabon'
  },
  {
    key: 'GAMBIA',
    value: 'Gambia'
  },
  {
    key: 'GEORGIA',
    value: 'Georgia'
  },
  {
    key: 'GHANA',
    value: 'Ghana'
  },
  {
    key: 'GREECE',
    value: 'Greece'
  },
  {
    key: 'GRENADA',
    value: 'Grenada'
  },
  {
    key: 'GUATEMALA',
    value: 'Guatemala'
  },
  {
    key: 'GUINEA',
    value: 'Guinea'
  },
  {
    key: 'GUINEA-BISSAU',
    value: 'Guinea-Bissau'
  },
  {
    key: 'GUYANA',
    value: 'Guyana'
  },
  {
    key: 'HAITI',
    value: 'Haiti'
  },
  {
    key: 'HOLY SEE',
    value: 'Holy See'
  },
  {
    key: 'HONDURAS',
    value: 'Honduras'
  },
  {
    key: 'HUNGARY',
    value: 'Hungary'
  },
  {
    key: 'ICELAND',
    value: 'Iceland'
  },
  {
    key: 'INDIA',
    value: 'India'
  },
  {
    key: 'INDONESIA',
    value: 'Indonesia'
  },
  {
    key: 'IRAN',
    value: 'Iran'
  },
  {
    key: 'IRAQ',
    value: 'Iraq'
  },
  {
    key: 'ISRAEL',
    value: 'Israel'
  },
  {
    key: 'JAMAICA',
    value: 'Jamaica'
  },
  {
    key: 'JAPAN',
    value: 'Japan'
  },
  {
    key: 'JORDAN',
    value: 'Jordan'
  },
  {
    key: 'KAZAKHSTAN',
    value: 'Kazakhstan'
  },
  {
    key: 'KENYA',
    value: 'Kenya'
  },
  {
    key: 'KIRIBATI',
    value: 'Kiribati'
  },
  {
    key: 'KUWAIT',
    value: 'Kuwait'
  },
  {
    key: 'KYRGYZSTAN',
    value: 'Kyrgyzstan'
  },
  {
    key: 'LAOS',
    value: 'Laos'
  },
  {
    key: 'LATVIA',
    value: 'Latvia'
  },
  {
    key: 'LEBANON',
    value: 'Lebanon'
  },
  {
    key: 'LESOTHO',
    value: 'Lesotho'
  },
  {
    key: 'LIBERIA',
    value: 'Liberia'
  },
  {
    key: 'LIBYA',
    value: 'Libya'
  },
  {
    key: 'LIECHTENSTEIN',
    value: 'Liechtenstein'
  },
  {
    key: 'LITHUANIA',
    value: 'Lithuania'
  },
  {
    key: 'LUXEMBOURG',
    value: 'Luxembourg'
  },
  {
    key: 'MADAGASCAR',
    value: 'Madagascar'
  },
  {
    key: 'MALAWI',
    value: 'Malawi'
  },
  {
    key: 'MALAYSIA',
    value: 'Malaysia'
  },
  {
    key: 'MALDIVES',
    value: 'Maldives'
  },
  {
    key: 'MALI',
    value: 'Mali'
  },
  {
    key: 'MALTA',
    value: 'Malta'
  },
  {
    key: 'MARSHALL ISLANDS',
    value: 'Marshall Islands'
  },
  {
    key: 'MAURITANIA',
    value: 'Mauritania'
  },
  {
    key: 'MAURITIUS',
    value: 'Mauritius'
  },
  {
    key: 'MEXICO',
    value: 'Mexico'
  },
  {
    key: 'MICRONESIA',
    value: 'Micronesia'
  },
  {
    key: 'MOLDOVA',
    value: 'Moldova'
  },
  {
    key: 'MONACO',
    value: 'Monaco'
  },
  {
    key: 'MONGOLIA',
    value: 'Mongolia'
  },
  {
    key: 'MONTENEGRO',
    value: 'Montenegro'
  },
  {
    key: 'MOROCCO',
    value: 'Morocco'
  },
  {
    key: 'MOZAMBIQUE',
    value: 'Mozambique'
  },
  {
    key: 'MYANMAR (FORMERLY BURMA)',
    value: 'Myanmar (formerly Burma)'
  },
  {
    key: 'NAMIBIA',
    value: 'Namibia'
  },
  {
    key: 'NAURU',
    value: 'Nauru'
  },
  {
    key: 'NEPAL',
    value: 'Nepal'
  },
  {
    key: 'NEW ZEALAND',
    value: 'New Zealand'
  },
  {
    key: 'NICARAGUA',
    value: 'Nicaragua'
  },
  {
    key: 'NIGER',
    value: 'Niger'
  },
  {
    key: 'NIGERIA',
    value: 'Nigeria'
  },
  {
    key: 'NORWAY',
    value: 'Norway'
  },
  {
    key: 'NORTH KOREA',
    value: 'North Korea'
  },
  {
    key: 'NORTH MACEDONIA',
    value: 'North Macedonia'
  },
  {
    key: 'OMAN',
    value: 'Oman'
  },
  {
    key: 'PAKISTAN',
    value: 'Pakistan'
  },
  {
    key: 'PALAU',
    value: 'Palau'
  },
  {
    key: 'PALESTINE STATE',
    value: 'Palestine State'
  },
  {
    key: 'PANAMA',
    value: 'Panama'
  },
  {
    key: 'PAPUA NEW GUINEA',
    value: 'Papua New Guinea'
  },
  {
    key: 'PARAGUAY',
    value: 'Paraguay'
  },
  {
    key: 'PERU',
    value: 'Peru'
  },
  {
    key: 'PHILIPPINES',
    value: 'Philippines'
  },
  {
    key: 'POLAND',
    value: 'Poland'
  },
  {
    key: 'PORTUGAL',
    value: 'Portugal'
  },
  {
    key: 'QATAR',
    value: 'Qatar'
  },
  {
    key: 'ROMANIA',
    value: 'Romania'
  },
  {
    key: 'RUSSIA',
    value: 'Russia'
  },
  {
    key: 'RWANDA',
    value: 'Rwanda'
  },
  {
    key: 'SAINT KITTS AND NEVIS',
    value: 'Saint Kitts and Nevis'
  },
  {
    key: 'SAINT LUCIA',
    value: 'Saint Lucia'
  },
  {
    key: 'SAINT VINCENT AND THE GRENADINES',
    value: 'Saint Vincent and the Grenadines'
  },
  {
    key: 'SAMOA',
    value: 'Samoa'
  },
  {
    key: 'SAN MARINO',
    value: 'San Marino'
  },
  {
    key: 'SAO TOME AND PRINCIPE',
    value: 'Sao Tome and Principe'
  },
  {
    key: 'SAUDI ARABIA',
    value: 'Saudi Arabia'
  },
  {
    key: 'SENEGAL',
    value: 'Senegal'
  },
  {
    key: 'SERBIA',
    value: 'Serbia'
  },
  {
    key: 'SEYCHELLES',
    value: 'Seychelles'
  },
  {
    key: 'SIERRA LEONE',
    value: 'Sierra Leone'
  },
  {
    key: 'SINGAPORE',
    value: 'Singapore'
  },
  {
    key: 'SLOVAKIA',
    value: 'Slovakia'
  },
  {
    key: 'SLOVENIA',
    value: 'Slovenia'
  },
  {
    key: 'SOLOMON ISLANDS',
    value: 'Solomon Islands'
  },
  {
    key: 'SOMALIA',
    value: 'Somalia'
  },
  {
    key: 'SOUTH AFRICA',
    value: 'South Africa'
  },
  {
    key: 'SOUTH KOREA',
    value: 'South Korea'
  },
  {
    key: 'SOUTH SUDAN',
    value: 'South Sudan'
  },
  {
    key: 'SPAIN',
    value: 'Spain'
  },
  {
    key: 'SRI LANKA',
    value: 'Sri Lanka'
  },
  {
    key: 'SUDAN',
    value: 'Sudan'
  },
  {
    key: 'SURINAME',
    value: 'Suriname'
  },
  {
    key: 'SYRIA',
    value: 'Syria'
  },
  {
    key: 'SWEDEN',
    value: 'Sweden'
  },
  {
    key: 'TAJIKISTAN',
    value: 'Tajikistan'
  },
  {
    key: 'TANZANIA',
    value: 'Tanzania'
  },
  {
    key: 'THAILAND',
    value: 'Thailand'
  },
  {
    key: 'TIMOR-LESTE',
    value: 'Timor-Leste'
  },
  {
    key: 'TOGO',
    value: 'Togo'
  },
  {
    key: 'TONGA',
    value: 'Tonga'
  },
  {
    key: 'TRINIDAD AND TOBAGO',
    value: 'Trinidad and Tobago'
  },
  {
    key: 'TUNISIA',
    value: 'Tunisia'
  },
  {
    key: 'TURKEY',
    value: 'Turkey'
  },
  {
    key: 'TURKMENISTAN',
    value: 'Turkmenistan'
  },
  {
    key: 'TUVALU',
    value: 'Tuvalu'
  },
  {
    key: 'UGANDA',
    value: 'Uganda'
  },
  {
    key: 'UKRAINE',
    value: 'Ukraine'
  },
  {
    key: 'UNITED ARAB EMIRATES',
    value: 'United Arab Emirates'
  },
  {
    key: 'UNKNOWN',
    value: 'Unknown'
  },
  {
    key: 'URUGUAY',
    value: 'Uruguay'
  },
  {
    key: 'UZBEKISTAN',
    value: 'Uzbekistan'
  },
  {
    key: 'VANUATU',
    value: 'Vanuatu'
  },
  {
    key: 'VENEZUELA',
    value: 'Venezuela'
  },
  {
    key: 'VIETNAM',
    value: 'Vietnam'
  },
  {
    key: 'YEMEN',
    value: 'Yemen'
  },
  {
    key: 'ZAMBIA',
    value: 'Zambia'
  },
  {
    key: 'ZIMBABWE',
    value: 'Zimbabwe'
  }
];
